import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Job } from '@sites/data-hmm/hmm-job';

export const modalComponentActions = createActionGroup({
  source: 'DashboardFeatureJob ModalComponent',
  events: {
    init: emptyProps(),
  },
});

export const panelComponentActions = createActionGroup({
  source: 'DashboardFeatureJob PanelComponent',
  events: {
    init: emptyProps(),
    refresh: emptyProps(),
  },
});

export const menuItemComponentActions = createActionGroup({
  source: 'DashboardFeatureJob MenuItemComponent',
  events: {
    init: emptyProps(),
  },
});

export const jobComponentActions = createActionGroup({
  source: 'DashboardFeatureJob JobComponent',
  events: {
    cancelJob: props<{
      job: Job;
    }>(),
  },
});
